module.exports = __webpack_public_path__ + "static/media/redesign-improvement.07284a54.svg";